import "./cms-list.css";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root"); // ป้องกัน warning ของ react-modal

function CommissionList() {
  const [activeCard, setActiveCard] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showFullImage, setShowFullImage] = useState(false);
  const [fullscreenImage, setFullscreenImage] = useState("");
  const cards = require("./card.json");

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleCardClick = (card) => {
    setActiveCard(card);
    setIsExpanded(true);
  };

  const closeExpanded = () => {
    setIsExpanded(false);
    setActiveCard(null);
  };

  const handleImageClick = (image) => {
    setFullscreenImage(image);
    setShowFullImage(true);
  };

  const closeFullImage = () => {
    setShowFullImage(false);
    setFullscreenImage("");
  };

  const goToNextImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % activeCard.images.length
    );
  };

  const goToPrevImage = () => {
    setCurrentImageIndex(
      (prevIndex) =>
        (prevIndex - 1 + activeCard.images.length) % activeCard.images.length
    );
  };

  const filteredCards = cards.filter((card) => {
    const matchesDescription = card.shortDescription
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const matchesTags = (card.tags || []).some((tag) =>
      tag.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return matchesDescription || matchesTags;
  });

  return (
    <div>
      <div className="search-container">
        {/* <button className="button" onClick={handleButtonClick}>
          *⚠︎ Conditions & Rules ⚠︎*
        </button> */}
        <input
          type="text"
          placeholder="Search..."
          className="search-bar"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="card-container">
        {filteredCards.map((card, index) => (
          <div
            key={index}
            className="card"
            onClick={() => handleCardClick(card)}
          >
            <div className="card-left">
              <img src={card.src} alt="Gallery" />
            </div>
            <div className="card-right">
              <p className="short-description">{card.shortDescription}</p>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={isExpanded}
        onRequestClose={closeExpanded}
        className="expanded-card-modal"
        overlayClassName="custom-overlay"
      >
        {activeCard && (
          <div className="expanded-card">
            <div className="expanded-card-left">
              <div className="full-image-container">
                <img
                  src={activeCard.images[currentImageIndex]}
                  alt="Full View"
                  onClick={() =>
                    handleImageClick(activeCard.images[currentImageIndex])
                  }
                />
                <button className="arrow left-arrow" onClick={goToPrevImage}>
                  &#8249;
                </button>
                <button className="arrow right-arrow" onClick={goToNextImage}>
                  &#8250;
                </button>
              </div>
            </div>
            <div className="expanded-card-right">
              <h1 className="full-description-title">
                {activeCard.fullDescriptionHead}
              </h1>
              <p className="full-des-text">{activeCard.fullDescription}</p>
              <ul>
                <li>Personal use : {activeCard.personal_use_price}$</li>
                <li>Commercial use : {activeCard.commercial_use_price}$</li>
                <li>
                  Exclusive right *no rules* : {activeCard.exclusive_right}$
                </li>
              </ul>
              <p className="add-on-text">Add on : {activeCard.other}</p>
              <p className="caution-text">{activeCard.caution}</p>
              <div className="button-container">
                <button
                  className="order-button"
                  onClick={() =>
                    window.open("https://forms.gle/8MdUGm8Vgw165rLQA", "_blank")
                  }
                >
                  ♡ Reserve
                </button>
                <button onClick={closeExpanded} className="close-button">
                  x Close
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Fullscreen Image Modal */}
      <Modal
        isOpen={showFullImage}
        onRequestClose={closeFullImage}
        className="fullscreen-modal"
        overlayClassName="custom-overlay" // เพิ่ม overlay class
      >
        <img
          src={fullscreenImage}
          alt="Fullscreen Image"
          className="fullscreen-image"
        />
      </Modal>
    </div>
  );
}

export default CommissionList;
